import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdRequestQuote } from 'react-icons/md';

import { useFormikContext } from 'formik';

import SettingsOption, { OptionType } from '../SettingsOption';
import TaxModal from './TaxModal';

const TaxSettings = () => {
  const { t } = useTranslation(['events']);
  const { values, setFieldValue } = useFormikContext<any>();

  const [showTaxModal, setShowTaxModal] = useState(false);

  const toggleTaxModal = () => {
    setShowTaxModal((showTaxModal) => !showTaxModal);
  };

  const onSave = (tax?: {
    taxId: string;
    name: string;
    ratePercent: number;
  }) => {
    setFieldValue('pricing.tax', tax || null);
  };

  return (
    <>
      <SettingsOption
        icon={<MdRequestQuote size={20} />}
        title={t('events:settings.tax.title')}
        actionLabel={t('events:settings.tax.actionLabel')}
        value={values?.pricing?.tax?.taxId}
        onClick={toggleTaxModal}
        tooltipMessage={t('events:settings.tax.tooltip')}
        type={OptionType.Button}
      />

      {showTaxModal && (
        <TaxModal
          onClose={toggleTaxModal}
          onSave={onSave}
          initialValues={values?.pricing?.tax}
        />
      )}
    </>
  );
};

export default TaxSettings;
